export const shopEndpoints = {
  getShopItems: '/api/products',
};
